export const AccessSchedule = {
    ALWAYS: 'always',
    TEMPORARY: 'temporary',
    RECURRING: 'recurring'
};
